const editUserStatus = async ({ user_id, new_status }) => {
  let response = await fetch(
    `${process.env.REACT_APP_API_URL}/Users/UpdatedUserStatus/${user_id}`,
    {
      method: "POST",
      body: JSON.stringify(`${new_status}`),
      headers: {
        "Content-Type": "application/json",
      },
    }
  ).catch((error) => {
    console.error("Error fetching data:", error);
  });

  return response.status === 204 ? true : false;
};
export default editUserStatus;
